import { z } from 'zod';
import { DepartmentSchema } from '../../entities/department/department.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Add Department Request Schema
 * POST /api/v2/departments (or bulk endpoint)
 * Compatible with bulk endpoint format
 */ export const AddDepartmentRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    description: z.string().optional(),
    abbreviation: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    manager: z.string().optional(),
    parent: z.string().optional()
});
/**
 * Add Department Response Schema
 * POST /api/v2/departments
 */ export const AddDepartmentResponseSchema = z.object({
    data: DepartmentSchema
});

//# sourceMappingURL=add-department.schema.js.map